import { render, staticRenderFns } from "./UdateApplicantContactInfo.vue?vue&type=template&id=634b7d14&scoped=true&"
import script from "./UdateApplicantContactInfo.vue?vue&type=script&lang=js&"
export * from "./UdateApplicantContactInfo.vue?vue&type=script&lang=js&"
import style0 from "./UdateApplicantContactInfo.vue?vue&type=style&index=0&id=634b7d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b7d14",
  null
  
)

export default component.exports